import { FC } from 'react'

import { PageSection, PageSectionFace } from 'ui/components'
import { PageButton } from 'ui/components/Buttons'
import { useAlertsContext } from '~bank-alerts/context'

export const CRBMonitor: FC = () => {
  const { data } = useAlertsContext()
  const { showCRBLicenseDisconnectedCount, showCRBLicenseEntityMismatchCount, showCRBLicenseStatusMismatchCount } = data

  return (
    <PageSection title="CRB Monitor" face={PageSectionFace.SECONDARY} anchor="crb-monitor">
      <div style={{ display: 'flex', gap: 20 }}>
        {showCRBLicenseDisconnectedCount > 0 && (
          <PageButton
            text={`${showCRBLicenseDisconnectedCount} CRB License ID — Inactive Status`}
            url="/crb-monitor?page=1&connectionStatus="
          />
        )}
        {showCRBLicenseEntityMismatchCount > 0 && (
          <PageButton
            text={`${showCRBLicenseEntityMismatchCount} License Number Mismatch`}
            url="/crb-monitor?page=1&connectionStatus=entity_mismatch"
          />
        )}
        {showCRBLicenseStatusMismatchCount > 0 && (
          <PageButton
            text={`${showCRBLicenseStatusMismatchCount} License Status Mismatch`}
            url="/crb-monitor?page=1&connectionStatus=status_mismatch"
          />
        )}
      </div>
    </PageSection>
  )
}
